import { DANGER_RED } from '../../primitives';

/** "Loading…", or the error that stopped a replacement from loading. */
export function TreeReplacementLoadState({ error }: { error: Error | null }) {
  if (error) {
    return (
      <div role="alert" style={{ color: DANGER_RED, fontSize: 13 }}>
        {error.message}
      </div>
    );
  }
  return <p style={{ margin: 0, fontSize: 13, color: 'var(--nb-subtle)' }}>Loading…</p>;
}
